export default __webpack_public_path__ + "static/media/wallet-icon.d1290b17.svg";